import Card from "./card";
import Transaction from "./transaction";
import Beneficiary from "./beneficiary";
export default {
  ...Card,
  ...Transaction,
  ...Beneficiary,
};
